import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "JawaiTrails";
const DEFAULT_TITLE = `${SITE} · Leopard Safaris in Jawai, Rajasthan`;
const DEFAULT_DESC = "Private leopard, jungle and birding jeep safaris in Jawai, Rajasthan. Book online with hotel pickup, expert naturalists and stays.";

function upsert(selector, create, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement(create); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}
const meta = (key, name, content) => {
  const el = document.head.querySelector(`meta[${key}="${name}"]`);
  if (!content) { el?.remove(); return; }
  upsert(`meta[${key}="${name}"]`, "meta", { [key]: name, content });
};

// Sets title, description, canonical, Open Graph/Twitter tags and optional JSON-LD for the current page (one set, no duplicates).
export function Seo({ title, description, image, type = "website", jsonLd, noindex }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;
    const img = image && image.startsWith("/") ? window.location.origin + image : image;
    const full = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    document.title = full;
    meta("name", "description", desc);
    meta("name", "robots", noindex ? "noindex" : "");
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: url });
    meta("property", "og:site_name", SITE);
    meta("property", "og:type", type);
    meta("property", "og:title", full);
    meta("property", "og:description", desc);
    meta("property", "og:url", url);
    meta("property", "og:image", img);
    meta("name", "twitter:card", img ? "summary_large_image" : "summary");
    meta("name", "twitter:title", full);
    meta("name", "twitter:description", desc);
    meta("name", "twitter:image", img);
    const old = document.getElementById("jt-jsonld");
    if (old) old.remove();
    if (ld) {
      const s = document.createElement("script");
      s.type = "application/ld+json"; s.id = "jt-jsonld"; s.text = ld;
      document.head.appendChild(s);
    }
  }, [title, description, image, type, ld, noindex]);
  return null;
}

// Resets head tags to site defaults on every route change; pages with <Seo> override right after.
export function SeoDefaults() {
  const { pathname: path } = useLocation();
  useEffect(() => {
    document.title = DEFAULT_TITLE;
    meta("name", "description", DEFAULT_DESC);
    meta("name", "robots", "");
    ["og:title", "og:description", "og:image", "og:url", "og:type"].forEach((k) => meta("property", k, ""));
    ["twitter:title", "twitter:description", "twitter:image"].forEach((k) => meta("name", k, ""));
    document.getElementById("jt-jsonld")?.remove();
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: window.location.origin + window.location.pathname });
  }, [path]);
  return null;
}
